export const ServicesData = [
    {
        index: '1',
        icon: (
            <i className="fas fa-heartbeat fa-3x" style={{ color: '#333' }}></i>
        ),
        title: 'Substance Use Rehabilitation',
        paragraph: 'Comprehensive treatment programs for drug and alcohol dependency.'
    },
    {
        index: '2',
        icon: (
            <i className="fas fa-user-md fa-3x" style={{ color: '#333' }}></i>
        ),
        title: 'Behavioral Therapy & Counseling',
        paragraph: 'Professional counseling to address underlying behavioral challenges.'
    },
    {
        index: '3',
        icon: (
            <i className="fas fa-procedures fa-3x" style={{ color: '#333' }}></i>
        ),
        title: 'Detoxification Support',
        paragraph: 'Medically supervised detox to safely manage withdrawal symptoms.'
    },
    {
        index: '4',
        icon: (
            <i className="fas fa-home fa-3x" style={{ color: '#333' }}></i>
        ),
        title: 'Residential Rehabilitation',
        paragraph: 'Structured inpatient care in a safe and supportive environment.'
    },
    {
        index: '5',
        icon: (
            <i className="fas fa-users fa-3x" style={{ color: '#333' }}></i>
        ),
        title: 'Aftercare & Relapse Prevention',
        paragraph: 'Ongoing support to maintain sobriety and prevent relapse.'
    }
];
